import { render } from "./MurojatAdd.vue?vue&type=template&id=251b0c72&scoped=true"
import script from "./MurojatAdd.vue?vue&type=script&lang=js"
export * from "./MurojatAdd.vue?vue&type=script&lang=js"

import "./MurojatAdd.vue?vue&type=style&index=0&id=251b0c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-251b0c72"]])

export default __exports__